module.exports = __webpack_public_path__ + "static/media/4ODA5.00a6f14a.jpg";